import { render } from "./TemplateMfittBookingTimeoutPage.vue?vue&type=template&id=3f35c633&scoped=true"
import script from "./TemplateMfittBookingTimeoutPage.vue?vue&type=script&lang=js"
export * from "./TemplateMfittBookingTimeoutPage.vue?vue&type=script&lang=js"

import "./TemplateMfittBookingTimeoutPage.vue?vue&type=style&index=0&id=3f35c633&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3f35c633"

export default script